import React, { useState } from "react";
import {
  Alert,
  Box, //
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useApp } from "../../../hooks/useApp";

type RemoveNetworkModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<"add-network" | "remove-network" | null>>;
  id: number;
};

export const RemoveNetworkModal: React.FC<RemoveNetworkModalProps> = ({ open, setOpen, id }) => {
  const app = useApp();
  const theme = useTheme();
  const network = app.networks.find((network) => network.id === id);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleClose = () => {
    setOpen(null);
  };

  const handleRemove = () => {
    app.removeNetwork(id);
    handleClose();

    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <React.Fragment>
      <Dialog //
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"xs"}
        aria-labelledby="remove-network-title"
        aria-describedby="remove-network-description"
      >
        <DialogTitle id="remove-network-title">Remove network</DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText id="remove-network-description" tabIndex={-1}>
            <Stack direction={"column"} gap={"1rem"} sx={{ width: "100%", py: "1rem" }}>
              <Typography textAlign={"center"} sx={{ fontWeight: 200, color: theme.palette.text.primary }}>
                Are you sure you want to remove this network?
              </Typography>
              <Box>
                <Typography textAlign={"center"} sx={{ color: theme.palette.text.primary, mb: "0.25rem" }}>
                  {network?.name}
                </Typography>
                <Typography textAlign={"center"} sx={{ fontWeight: 200, fontSize: "0.8rem" }}>
                  {network?.address}
                </Typography>
              </Box>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Stack direction={"row"} justifyContent={"center"} gap={"2rem"} sx={{ width: "100%" }}>
            <Button onClick={handleClose} variant="text" color="info">
              Cancel
            </Button>
            <Button onClick={handleRemove} variant="contained" color="error">
              Remove
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
      <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={handleCloseSnackbar}>
        <Alert
          onClose={handleCloseSnackbar} //
          severity="success"
          variant="filled"
          sx={{ width: "100%", "& svg": { color: "white" }, "& div": { color: "white" } }}
          icon={false}
        >
          Network removed!
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};
